export default __webpack_public_path__ + "static/media/IconF3.7257fa67.svg";